import { formatInTimeZone } from "date-fns-tz";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import DateRangeComp from "../../common/DateRangeComp";
import { getCookie } from "../../slidebar/components/DarkMode";
import * as actions from "../redux/ReportAction";

export const WinLoseDetails = ({ detailQuery, setDetailQuery }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const reportState = useSelector(({ report }) => report, shallowEqual);
  const [mode, setMode] = useState(getCookie("selectedTheme"));
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const timeZone = "Asia/Kuala_Lumpur";

  const handleClose = () => setDetailQuery(undefined);

  useEffect(() => {
    const handle = () => {
      setMode((prev) => (prev === "dark" ? "light" : "dark"));
    };

    window.addEventListener("setTheme", handle);

    return () => {
      window.removeEventListener("setTheme", handle);
    };
  }, []);

  useEffect(() => {
    if (detailQuery) {
      setFromDate(detailQuery.fromdate);
      setToDate(detailQuery.todate);
      const formattedFromDate = formatInTimeZone(
        detailQuery.fromdate,
        timeZone,
        "yyyy-MM-dd"
      );
      const formattedToDate = formatInTimeZone(
        detailQuery.todate,
        timeZone,
        "yyyy-MM-dd"
      );
      dispatch(
        actions.getWinLoseDetail({
          ...detailQuery,
          title: undefined,
          fromdate: formattedFromDate,
          todate: formattedToDate,
        })
      );
    } else {
      dispatch(actions.clearWinLoseDetail());
    }
  }, [detailQuery]);

  const handleDateChange = (start, end) => {
    setFromDate(start);
    setToDate(end);
  };

  return (
    <>
      <Modal
        size="lg"
        show={!!detailQuery}
        onHide={handleClose}
        centered
        data-bs-theme={mode}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {detailQuery?.title}{" "}
            {intl.formatMessage({
              id: "details",
            })}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="dateSearch-div mb-4">
            <div className="dateRange-div border rounded">
              <DateRangeComp
                initialRange={[
                  { startDate: fromDate, endDate: toDate, key: "selection" },
                ]}
                onDateChange={handleDateChange}
              />
            </div>
            <div className="d-flex align-items-center">
              {reportState.searchLoading && (
                <div
                  className="spinner-border me-1"
                  role="status"
                  style={{ scale: "0.55" }}
                >
                  <span className="sr-only"></span>
                </div>
              )}
              <button
                className="btn btn-primary"
                onClick={() =>
                  setDetailQuery((prev) => ({
                    ...prev,
                    fromdate: fromDate,
                    todate: toDate,
                  }))
                }
              >
                {intl.formatMessage({ id: "search" })}
              </button>
            </div>
          </div>
          {reportState.winLoseDetail && (
            <>
              <div className="fw-semibold fs-5">
                {intl.formatMessage({ id: "agent" })}
              </div>
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>{intl.formatMessage({ id: "username" })}</th>
                      <th className="text-end">
                        {intl.formatMessage({ id: "amount" })}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {reportState.winLoseDetail.agentRpLists.map((agentRp) => (
                      <tr key={agentRp.masterid}>
                        <td>{agentRp.username}</td>
                        <td className="text-end">{agentRp.amount}</td>
                      </tr>
                    ))}
                    {reportState.winLoseDetail.agentRpLists.length === 0 ? (
                      <tr>
                        <td colSpan={2} className="text-center">
                          {intl.formatMessage({ id: "noRecordFound" })}
                        </td>
                      </tr>
                    ) : (
                      <tr>
                        <td colSpan={2} className="text-end">
                          {intl.formatMessage({ id: "total" })}
                          {" : "}
                          {reportState.winLoseDetail.downlinetotalamount}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="fw-semibold fs-5">
                {intl.formatMessage({ id: "member" })}
              </div>
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>{intl.formatMessage({ id: "username" })}</th>
                      <th className="text-end">
                        {intl.formatMessage({ id: "amount" })}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {reportState.winLoseDetail.memberRpLists.map((memberRp) => (
                      <tr key={memberRp.memberid}>
                        <td>{memberRp.username}</td>
                        <td className="text-end">{memberRp.amount}</td>
                      </tr>
                    ))}
                    {reportState.winLoseDetail.memberRpLists.length === 0 ? (
                      <tr>
                        <td colSpan={2} className="text-center">
                          {intl.formatMessage({ id: "noRecordFound" })}
                        </td>
                      </tr>
                    ) : (
                      <tr>
                        <td colSpan="2" className="text-end">
                          {intl.formatMessage({ id: "total" })} {" : "}
                          {reportState.winLoseDetail.membertotalamount}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="fw-semibold fs-5">
                {intl.formatMessage({ id: "paymentGateway" })}
              </div>
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>{intl.formatMessage({ id: "no" })}</th>
                      <th>{intl.formatMessage({ id: "gatewayName" })}</th>
                      <th className="text-end">
                        {intl.formatMessage({ id: "amount" })}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {reportState.winLoseDetail.winLose_PaymentGateways?.map(
                      (winlosePG, index) => (
                        <tr key={winlosePG.gatewaycode}>
                          <td>{index + 1}</td>
                          <td>{winlosePG.gatewayname}</td>
                          <td className="text-end">{winlosePG.amount}</td>
                        </tr>
                      )
                    )}
                    {(!reportState.winLoseDetail.winLose_PaymentGateways ||
                      reportState.winLoseDetail.winLose_PaymentGateways
                        ?.length === 0) && (
                      <tr>
                        <td colSpan={3} className="text-center">
                          {intl.formatMessage({ id: "noRecordFound" })}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};
